import { React } from "react";
import GradientBackground from "../lib/neatGradients";

const LaunchingUI = () => {
  return (
    <>
      <GradientBackground text="Coming Soon!">
        <div className="p-4 text-center "></div>
      </GradientBackground>
    </>
  );
};

export default LaunchingUI;
